<template>
  <div class="col row mt-md-3 mt-lg-0 contact-info">
    <div class="col-auto">
      <img
        :src="`/static/assets/imgs/${imageName}`"
        :alt="altText"
        class="rounded-circle"
        style="width: 50px"
      />
    </div>
    <div class="col ml-3 ml-lg-0 pl-0">
      <div class="row mb-1">
        <div class="col-1 pl-0 pr-3"></div>
        <div class="col pl-0 consultant-name">{{ title }}</div>
      </div>
      <div class="row flex-nowrap">
        <div
          class="col-1 pl-0 pr-2 d-flex align-items-center justify-content-end"
        >
          <span class="phone-icon fa fa-phone"></span>
        </div>
        <div class="col pl-0 text-nowrap contact-phone">
          {{ contactType }}:
          <a :href="phoneURl" class="consultant-phone_number">{{
            phoneNumber
          }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imageName: String,
    altText: String,
    title: String,
    contactType: String,
    phoneNumber: String,
  },
  computed: {
    phoneURl: function () {
      return "tel:" + this.phoneNumber.replaceAll("-", "");
    },
  },
};
</script>

<style lang="scss" scoped>
.phone-icon {
  color: #5456ff;
}

.consultant-name {
  color: #696969;
  font-size: 12px;
  font-weight: 600;
}

.contact-phone {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// ContactInfo.vue?d4351a5a